import React, { Component } from 'react';
import PropTypes from 'prop-types';
import RCPagination from '../../UserControl/Pagination/RCPagination';
import { checkStatus,getMonthTHFromInt } from '../../../../util/util';
import { withNamespaces } from 'react-i18next';
import ModalConfirmUserInformation from '../../../Modals/ModalConfirmUserInformation';
import {AlertConfirm, AlertCommit} from '../../../Modals/AlertBar';


class AccessLog extends Component {
    constructor() {
        super();
        this.state  = {
            logList:[],
            logSearch:'',
            currentPage:1,
            currentPageSize:10,
            totalPage:0,
        };
    }

    componentDidMount(){
        this.onPageSizeChange(this.state.currentPage,this.state.currentPageSize);
    }

    componentWillUnmount(){

    }

    onPageSelect(page){

        const { currentPageSize,logSearch } = this.state;
        const { user_id, user_name,token} = this.props;
        fetch(`http://203.150.199.244/api/admin/getAccessLog/${page}/${currentPageSize}`, {
            method: 'post',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                // "user_id": user_id,
                // "user_name": user_name,
                "token": token
            },
            body: JSON.stringify({
                // "filter":logSearch
            })
            })
            .then(response => { return checkStatus(response)})
            .then(data => {
                this.setState({
                    logList:data.RESULT_DATA,
                    totalPage:data.RESULT_TOTAL,
                    currentPage:page,currentPageSize:currentPageSize})

            })
            .catch(function (err) {
                console.log('err:', err);
                // POST failed...
            });

    }

    onPageSizeChange(page, pageSize){

        const { currentPageSize,logSearch } = this.state;
        const { user_id, user_name,token} = this.props;

        fetch(`http://203.150.199.244/api/admin/getAccessLog/${page}/${pageSize}`, {
            method: 'post',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                // "user_id": user_id,
                // "user_name": user_name,
                "token": token
            },
            body: JSON.stringify({
                // "filter":logSearch
            })
            })
            .then(response => { return checkStatus(response)})
            .then(data => {
                this.setState({
                    logList:data.RESULT_DATA,
                    totalPage:data.RESULT_TOTAL,
                    currentPage:page,currentPageSize:pageSize})
            })
            .catch(function (err) {
                console.log('err:', err);
                // POST failed...
            });


    }

    // onSubmitNewDevice = (dataNewDevice) => {
    //     this.setState({
    //         // showModalConfirmNewDevice: true,
    //         dataNewDevice
    //     });

    //     AlertConfirm("เพิ่ม Device","คุณต้องการบันทึกข้อมูลหรือไม่").then(isOk=>{
    //         if(isOk){
    //             const {
    //                 user_name,
    //                 user_id,
    //                 token
    //             } = this.props;

    //             const { dataNewDevice } = this.state;

    //             fetch(`http://203.150.199.244/api/admin/newDevice`, {
    //                 method: 'post',
    //                 headers: {
    //                     "Content-Type": "application/json; charset=utf-8",
    //                     "user_id": user_id,
    //                     "user_name": user_name,
    //                     "token": token
    //                 },
    //                 body: JSON.stringify({
    //                     "serial": dataNewDevice.serial,
    //                     "imei": dataNewDevice.imei,
    //                     "sim_no": dataNewDevice.simNo,
    //                     "model": dataNewDevice.model,
    //                     "vendor": dataNewDevice.vendor
    //                 })
    //             })
    //                 .then(response => { return checkStatus(response)})
    //                 .then((data) => {

    //                     if(data.RESULT_STATUS == "000")
    //                         AlertCommit(true,"บันทึกข้อมูลเรียบร้อยแล้ว");
    //                     else{
    //                         AlertCommit(false,data.RESULT_STATUS + ": "+data.RESULT_MESSAGE);
    //                     }


    //                     this.setState({
    //                         showModalConfirmNewDevice: false,
    //                         isNewDevice: false,
    //                         // notification: true
    //                     })
    //                 })
    //                 // .then(setTimeout(() => {
    //                 //     this.setState({notification: false});
    //                 // }, 3000))
    //                 .then(() => {
    //                     this.onPageSizeChange(this.state.currentPage, this.state.currentPageSize)
    //                 })
    //                 .catch(function (err) {
    //                     console.log('err:', err);
    //                     // POST failed...
    //                 });
    //         }
    //     });
    // }


    // editeDevice(device, key){
    //     console.log('editeDevice:', key)
    //     this.setState({
    //         deviceSelectID:device.device_id,
    //         isShowEdit:true,
    //         deviceSelected:device,
    //     })
    // }

    // onEditDeviceClose(){
    //     this.btnEditClose.click();
    //     this.onPageSizeChange(this.state.currentPage,this.state.currentPageSize);
    //     this.setState({
    //         isShowEdit:false
    //     })
    // }

    // deleteDevice(device){
    //     this.setState({
    //         deviceSelectID:device.device_id,
    //         // ShowDeleteRow: true,
    //     })

    //     AlertConfirm("ลบ Device","คุณต้องการลบ Device หรือไม่").then(isOk=>{
    //         if(isOk){
    //             const {
    //                 user_name,
    //                 user_id,
    //                 sideBarName,
    //                 token,
    //             } = this.props;

    //             const { deviceSelectID } = this.state;

    //             fetch(`http://203.150.199.244/api/admin/deleteDevice/${deviceSelectID}`, {
    //                 method: 'post',
    //                 headers: {
    //                     "Content-Type": "application/json; charset=utf-8",
    //                     // "user_id": user_id,
    //                     // "user_name": user_name,
    //                     "token":token,
    //                 },
    //                 body: JSON.stringify({
    //                     // "device_status":"Inactive"
    //                 })
    //             })
    //                 .then(response => { return checkStatus(response)})
    //                 .then((data) => {

    //                     if(data.RESULT_STATUS == "000")
    //                         AlertCommit(true,"ลบข้อมูลเรียบร้อยแล้ว");
    //                     else{
    //                         AlertCommit(false,data.RESULT_STATUS + ": "+data.RESULT_MESSAGE);
    //                     }

    //                     this.setState({
    //                         ShowDeleteRow: false,
    //                         // notification: true
    //                      })
    //                 })
    //                 // .then(setTimeout(() => {
    //                 //     this.setState({ notification: false });
    //                 // }, 3000))
    //                 .then(() => {

    //                         // if (sideBarName === 'deviceInformation') {
    //                             this.onPageSizeChange(this.state.currentPage, this.state.currentPageSize)
    //                             // console.log(sideBarName);
    //                         // }
    //                     }
    //                 )
    //                 .catch(function (err) {
    //                     console.log('err:', err);
    //                     // POST failed...
    //                 });
    //     }
    // });
    // }

    // convertDateFormat(date){
    //     let dateString = date.substring(0,10);
    //     let str = dateString.split("-");
    //     let year = parseInt(str[2])+543;
    //     let month = getMonthTHFromInt(parseInt(str[1]));
    //     return str[0]+' '+month.toString()+' '+year.toString();
    // }

    convertDateFormat(date){

        let date_time = date.split(" ");
        let time = date_time[1];
        let dateString = date_time[0].substring(0,10);
        let str = dateString.split("-");
        let year = parseInt(str[0])+543;
        let month = getMonthTHFromInt(parseInt(str[1]));
        return str[2]+' '+month.toString()+' '+year.toString() +', '+time;
    }

    handleChange = (event) => {
        var val = event.target.value;

        this.setState({
            logSearch: val
        });

        // this.onPageSizeChange(this.state.currentPage,this.state.currentPageSize);
    }

    onClickSearch = () => {

        let name = this.state.logSearch;

        this.setState({logSearch:name});
        this.onPageSizeChange(this.state.currentPage,this.state.currentPageSize);
    }

    render(){

        const {
            logList,
            currentPageSize,
            totalPage,
            currentPage,
        }=this.state;

        const { t, user_id, user_name,token, sideBarName ,userLevel} = this.props;

        let rows=[];
        logList.map((log,key)=>{
            rows.push(
                <tr key={key}>
                <td>{(currentPage - 1) * currentPageSize + (key+1)}</td>
                <td >{log.ip}</td>
                <td>{log.agent}</td>
                <td>{log.access_time ? this.convertDateFormat(log.access_time) : log.access_time}</td>
                </tr>
            )

        });

        return(

        <div className="gray-panel">

                    <div className="col-md-12">
                        <h6 className="page-header"> <i className="fa fa-list-alt" style={{color: '#7386D5'}} />&nbsp;{t('ประวัติการเข้าระบบ')}</h6>
                    </div>
                    <br />
                    {/* <div className="form-inline form-group">
                        <label htmlFor="focusedInput" className="col-md-1">ค้นหา</label>
                        <input className="form-control col-md-3 " id="focusedInput" type="text" onChange={this.handleChange} />
                        <div className="col-md-1" >
                            <input type="button" className="btn btn-info" value="ค้นหา" onClick={this.onClickSearch} />
                        </div>
                    </div> */}
                     <div className="col-md-12 table-responsive">
                        <table  className="table table-bordred table-striped table-hover ">
                            <thead >
                            <tr>
                            <th>#</th>
                            <th style={{minWidth:120}}>IP</th>
                            <th style={{minWidth:120}}>Agent</th>
                            <th style={{minWidth:150}}>เวลาเข้าระบบ</th>
                            </tr></thead>
                        <tbody>
                            {rows}
                        </tbody>
                        </table>
                    </div>
                    <RCPagination
                        onSelect={this.onPageSelect.bind(this)}
                        onShowSizeChange={this.onPageSizeChange.bind(this)}
                        total={totalPage}
                        pageSize={currentPageSize}
                    />

                </div>

        );
    }
}

AccessLog.propTypes = {
    t: PropTypes.func.isRequired,
    userLevel: PropTypes.number.isRequired,
    user_name: PropTypes.string.isRequired,
    user_id: PropTypes.number.isRequired,
    token: PropTypes.string.isRequired,
    sideBarName: PropTypes.string.isRequired
}

export default withNamespaces('Menubar')(AccessLog);



// WEBPACK FOOTER //
// ./src/app/view/components/AdminConfig/Content/AccessLog.js